import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'SnackBarNotif',
  setup(__props) {

const store             = useStore();

const snackbarAdd       = computed( ()=> store.state.snackbarAdd    );
const snackbarEdit      = computed( ()=> store.state.snackbarEdit   );
const snackbarError     = computed( ()=> store.state.snackbarError  );
const snackbarDelete    = computed( ()=> store.state.snackbarDelete );
const snackMessage      = computed( ()=> store.state.snackbarmsg    );
       

return (_ctx: any,_cache: any) => {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_snackbar, {
      modelValue: snackbarAdd.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snackbarAdd).value = $event)),
      color: "success"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbarEdit.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((snackbarEdit).value = $event)),
      color: "orange-darken-2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbarDelete.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((snackbarDelete).value = $event)),
      color: "#FF3019"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: snackbarError.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((snackbarError).value = $event)),
      color: "error"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(snackMessage.value), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})